var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResources(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.46216 20.6001C8.00582 21.7233 9.82264 22.4116 11.723 22.5933C13.6234 22.7749 15.5377 22.4432 17.2662 21.6328C18.9947 20.8223 20.474 19.5628 21.5498 17.9858C22.6255 16.4087 23.2584 14.5718 23.3822 12.6667H13.0355L6.46216 20.6001Z",
    fill: "",
    fillOpacity: 0.86
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3821 11.3333C23.3602 10.9737 23.3202 10.6155 23.2621 10.26H15.5687C15.1376 10.2637 14.7131 10.1537 14.338 9.94113C13.9629 9.72855 13.6505 9.42088 13.4321 9.0491C13.2138 8.67733 13.0973 8.25458 13.0944 7.82345C13.0914 7.39231 13.2022 6.96802 13.4154 6.5933L16.1221 1.92664C13.8303 1.18592 11.3553 1.24261 9.09984 2.0875C6.84438 2.93238 4.94125 4.51571 3.70016 6.57983C2.45906 8.64394 1.95306 11.0673 2.2645 13.4556C2.57593 15.8439 3.68648 18.0565 5.4154 19.7333L12.4087 11.3333H23.3821Z",
    fill: "",
    fillOpacity: 0.86
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6488 0.760039L14.8355 7.33337C14.7468 7.46359 14.6958 7.61583 14.6883 7.77322C14.6808 7.93061 14.7171 8.08701 14.793 8.22507C14.8689 8.36314 14.9816 8.47748 15.1186 8.55543C15.2555 8.63338 15.4113 8.6719 15.5688 8.6667H23.2022C23.3596 8.6719 23.5155 8.63338 23.6524 8.55543C23.7894 8.47748 23.902 8.36314 23.978 8.22507C24.0539 8.08701 24.0901 7.93061 24.0826 7.77322C24.0751 7.61583 24.0242 7.46359 23.9355 7.33337L20.1222 0.760039C20.047 0.631409 19.9394 0.524713 19.8101 0.450565C19.6809 0.376417 19.5345 0.337402 19.3855 0.337402C19.2365 0.337402 19.0901 0.376417 18.9608 0.450565C18.8316 0.524713 18.724 0.631409 18.6488 0.760039V0.760039Z",
    fill: "",
    fillOpacity: 0.86
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResources);
export default __webpack_public_path__ + "static/media/resources.a55df43a5fd144232ec4f184b832cdd2.svg";
export { ForwardRef as ReactComponent };